(function() {
  if (document.querySelector('.pagination--infinite-scroll')) {
    let loading = false;
    const container = document.querySelector('.collection-grid');
    const paginationContainer = document.querySelector('.pagination--infinite-scroll');
    const spinner = paginationContainer.querySelector('.loading-spinner');
    let nextUrl = paginationContainer.dataset.nextUrl;

    function loadMore() {
      if (loading || !nextUrl) return;
      
      loading = true;
      spinner.style.display = 'block';

      fetch(nextUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          
          // Get new products
          const newProducts = doc.querySelectorAll('.collection-grid > .grid__item');
          newProducts.forEach(product => {
            container.appendChild(product);
          });

          if (window.theme && typeof theme.productGridImageSwipe === 'function') {
            theme.productGridImageSwipe();
          }

          // Update next URL
          const newPagination = doc.querySelector('.pagination--infinite-scroll');
          if (newPagination && newPagination.dataset.nextUrl) {
            nextUrl = newPagination.dataset.nextUrl;
          } else {
            nextUrl = null;
            paginationContainer.style.display = 'none';
          }

          loading = false;
          spinner.style.display = 'none';
        })
        .catch(error => {
          console.error('Error loading more products:', error);
          loading = false;
          spinner.style.display = 'none';
        });
    }

    // Detect when user scrolls near bottom
    function checkScroll() {
      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      
      // Load more when user is 200px from bottom
      if (scrollPosition >= pageHeight - 200) {
        loadMore();
      }
    }

    window.addEventListener('scroll', checkScroll);
  }
})();